import * as types from './types';
import Box from '../../../../helpers/request/box';

const BoxRequest = new Box();

export const metricsRequestData = ({ commit, rootState }) => {
  const boxId = rootState.route.params.boxId;

  BoxRequest.metrics(boxId)
    .then(response => commit(types.METRICS_SET_DATA, response.data));
};

export const metricsResetState = ({ commit }) => {
  commit(types.METRICS_RESET_STATE);
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/metrics/actions.js
 **/